import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 0,
  headers: {
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
});
localStorage.setItem('baseURL', process.env.VUE_APP_API_URL)
apiClient.interceptors.response.use((response) => response, (error) => {
  if (error.response.status == 401) {
    // Session expired
    if (window.location.pathname != '/login') {
      localStorage.setItem('login_error', 'Your session has expired. Please sign in again.')
      localStorage.removeItem('token')
      localStorage.removeItem('ShowModal')
      this.state.auth = false
      window.location.href = '/login'
    }
  } else {
    // Generic error
    Promise.reject(error)
  }
});

export default apiClient